export default "__VITE_ASSET__DxA5Wxt8__"